import useHandler from "./handler";
import "./styles.sass";

export const PersonalJourney = () => {
  const {
    boardCards,
    step,
    selectedBoards,
    genders,
    boards,
    data,
    gradeClass,
    error,
    showOnlyInstitutionAndMedium,
    mediumInstruction,
    focusRes,
    setStep,
    setSelectedBoards,
    toggleBoard,
    onChangeValue,
    onFoucess,
    onSubmit,
    hasNeetOrJee,
  } = useHandler();
  const { board, institution, gender, grade, medium_of_instruction, section } =
    data;
  const {
    errInstitution,
    errMediumOfInstruction,
    errGender,
    errEducationLevel,
    errGradeClass,
    errBoard,
    errSection,
  } = error;

  return (
    <section className="journey">
      <h1>Personalize your journey</h1>

      <p>
        Pick the exams and boards you're preparing for — you can change these
        anytime.
      </p>

      {step === 1 && (
        <>
          <section className="journey_board_container">
            <div className="journey_header">
              <h3>Exams & Boards</h3>

              <span>
                {selectedBoards
                  ? `${selectedBoards.length} Selected`
                  : "0 Selected"}
              </span>
            </div>

            <div className="journey_board_grid">
              {boardCards.map((board) => (
                <div
                  key={board.id}
                  className={`journey_board_card ${selectedBoards.some(
                    (item) => (item.id === board.id ? "active" : ""),
                  )}`}
                  onClick={() => toggleBoard(board)}
                >
                  {selectedBoards.some((item) => item.id === board.id) && (
                    <div className="selected_icon">✓</div>
                  )}
                  <div className="icon">{board.icon}</div>
                  <h4>{board.title}</h4>
                  <small>{board.subtitle}</small>
                </div>
              ))}
            </div>
          </section>

          <section className="journey_footer">
            <section className="journey_steps">
              {[1, 2].map((item) => (
                <span
                  key={item}
                  className={`step_dot ${step === item ? "active" : ""}`}
                />
              ))}
            </section>
            <section
              className={`journey_continue_wrapper ${
                selectedBoards.length === 0 ? "disabled" : ""
              }`}
              disabled={selectedBoards.length === 0}
              onClick={onFoucess}
            >
              Continue
            </section>
          </section>
        </>
      )}

      {step === 2 && (
        <>
          <section className="journey_selected_header">
            <div className="journey_selected_header_tabs">
              <h5>Exams & Boards</h5>
              {focusRes?.map((item, index) => (
                <div className="journey_tag" key={index}>
                  <h5>{item}</h5>
                </div>
              ))}
            </div>

            <section className="journey_edit" onClick={() => setStep(1)}>
              Edit
            </section>
          </section>

          <section className="journey_about">
            <h3>About you</h3>

            <div className="journey_row">
              {/* <section className="journey_dropdown_wrapper">
                <select name="gender" value={gender} onChange={onChangeValue}>
                  <option value="" disabled>
                    Select Gender
                  </option>
                  {genders?.map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
                {errGender && <p>{errGender}</p>}
              </section> */}
              {!showOnlyInstitutionAndMedium && (
                <>
                  <section className="journey_dropdown_wrapper">
                    <input
                      placeholder="Enter Section"
                      name="section"
                      value={section}
                      onChange={onChangeValue}
                    />
                    {errSection && (
                      <p className="personal_error_text">{errSection}</p>
                    )}
                  </section>
                  <section className="journey_dropdown_wrapper">
                    <select name="grade" value={grade} onChange={onChangeValue}>
                      <option value="" disabled>
                        Select Grade
                      </option>
                      {gradeClass?.map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                    {errGradeClass && (
                      <p className="personal_error_text">{errGradeClass}</p>
                    )}
                  </section>
                </>
              )}
            </div>

            <div className="journey_row">
              {!showOnlyInstitutionAndMedium && (
                <section className="journey_dropdown_wrapper">
                  <select name="board" value={board} onChange={onChangeValue}>
                    <option value="" disabled>
                      Select Board
                    </option>
                    {boards?.map((item, index) => (
                      <option key={index}>{item}</option>
                    ))}
                  </select>
                  {errBoard && (
                    <p className="personal_error_text">{errBoard}</p>
                  )}
                </section>
              )}

              <section className="journey_dropdown_wrapper">
                <input
                  placeholder="Institution Name"
                  name="institution"
                  value={institution}
                  onChange={onChangeValue}
                />
                {errInstitution && (
                  <p className="personal_error_text">{errInstitution}</p>
                )}
              </section>
            </div>

            {showOnlyInstitutionAndMedium && hasNeetOrJee && (
              <section className="journey_row">
                <select name="grade" value={grade} onChange={onChangeValue}>
                  <option value="" disabled>
                    Select Grade
                  </option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </select>

                {errGradeClass && (
                  <p className="personal_error_text">{errGradeClass}</p>
                )}
              </section>
            )}

            <div className="journey_row">
              <section className="journey_dropdown_wrapper">
                <select
                  name="medium_of_instruction"
                  value={medium_of_instruction}
                  onChange={onChangeValue}
                >
                  <option value="" disabled>
                    Select Medium
                  </option>
                  {mediumInstruction?.map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
                {errMediumOfInstruction && (
                  <p className="personal_error_text">
                    {errMediumOfInstruction}
                  </p>
                )}
              </section>
            </div>
          </section>

          <section className="journey_footer">
            <section className="journey_steps">
              {[1, 2].map((item) => (
                <span
                  key={item}
                  className={`step_dot ${step === item ? "active" : ""}`}
                />
              ))}
            </section>
            <section className="journey_continue_wrapper" onClick={onSubmit}>
              Submit
            </section>
          </section>
        </>
      )}
    </section>
  );
};
